import { cx } from "./classNames";

/**
 * Semantic typography role classes generated by @texturehq/edges-tokens.
 *
 * These classes apply the full type role — family, size, line-height,
 * weight, and letter-spacing. Pair them with explicit semantic text-color
 * utilities at the callsite.
 */
export const typographyRole = {
  displayXl: "text-display-xl",
  displayLg: "text-display-lg",
  displayMd: "text-display-md",
  displaySm: "text-display-sm",
  headingXl: "text-heading-xl",
  headingLg: "text-heading-lg",
  headingMd: "text-heading-md",
  headingSm: "text-heading-sm",
  bodyLg: "text-body-lg",
  bodyMd: "text-body-md",
  bodySm: "text-body-sm",
  labelLg: "text-label-lg",
  labelMd: "text-label-md",
  labelSm: "text-label-sm",
  code: "text-code",
  agent: "text-agent",
} as const;

export type TypographyRole = keyof typeof typographyRole;

/**
 * Merge a semantic typography role with semantic color utilities and any
 * component-specific layout classes. This keeps components from hand-composing
 * `text-sm font-medium leading-*` whenever a role exists.
 */
export function typeRole(role: TypographyRole, ...classNames: Array<string | false | null | undefined>): string {
  return cx(typographyRole[role], ...classNames);
}
